module.exports = __webpack_public_path__ + "img/icon-coffee.c464f4dd.svg";